import { mesfColors } from "@/setup/ag-grid/mesf-theme";
import type { VisualizerStatus } from "../models/MillVisualizer";

// Status → stand border colour. Uses mesfColors tokens so the visualizer stays
// visually consistent with the rest of the (light-themed) app.
export const statusToBorder = (status: VisualizerStatus): string => {
	switch (status) {
		case "rolling":
			return mesfColors.success.main;
		case "warning":
			return mesfColors.warning.main;
		case "fault":
			return mesfColors.error.main;
		default:
			return mesfColors.text.secondary;
	}
};

// Inactive / "off" stand fill (very light grey). Active stands get white fill.
export const statusToFill = (status: VisualizerStatus): string =>
	status === "idle" ? mesfColors.grey[100] : mesfColors.background.paper;
